export default "__VITE_ASSET__2fcfc8d7__"